export default __webpack_public_path__ + "static/media/bus_redencao_2.f1e5d7a9.png";